import { useRef, useState } from 'react'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'
import ViewCone from './ViewCone'

export default function Boid (props) {
    const ref = useRef()
    var speed = 5.0
    var rot_speed = 2.0
    var bounds = 10.0
    var size = 0.2
    // const velocity = new THREE.Vector3(1.0, 1.0, 1.0)

    useFrame((_, delta) => {
        var direction = new THREE.Vector3(0, 1, 0)
        direction.applyQuaternion( ref.current.quaternion )
        // https://stackoverflow.com/a/68811047
        
        ref.current.position.x += delta * speed * direction.x
        ref.current.position.y += delta * speed * direction.y
        ref.current.position.z += delta * speed * direction.z

        // console.log(ref.current.position)

        ref.current.rotation.y += delta * rot_speed * THREE.MathUtils.randInt(0, 1) * -1
        ref.current.rotation.z += delta * rot_speed * THREE.MathUtils.randInt(0, 1) * -1

        if (ref.current.position.x >= bounds){
            ref.current.position.x = -bounds
        }
        else if (ref.current.position.x <= -bounds){
            ref.current.position.x = bounds
        }

        if (ref.current.position.y >= bounds){
            ref.current.position.y = -bounds
        }
        else if (ref.current.position.y <= -bounds){
            ref.current.position.y = bounds
        }

        if (ref.current.position.z >= bounds){
            ref.current.position.z = -bounds
        }
        else if (ref.current.position.z <= -bounds){
            ref.current.position.z = bounds
        }

        
    })

    return (
        <mesh {...props} ref={ref}>
            <coneGeometry args={[size, size*5.0, 4]} />
            <meshBasicMaterial color={0x62ff00} />
            <ViewCone position={[0, 3, 0]} rotation={[Math.PI, 0, 0]} visible={false} />
            {/* <axesHelper /> */}
        </mesh>
    )
}